// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.4456 22.2358L11.7304 21.6641C10.2196 21.1605 9.20047 19.7465 9.20047 18.154V15.7H5.3317C3.49304 15.7 2.087 14.0611 2.36658 12.2438L3.5512 4.54383C3.77635 3.08034 5.0356 2 6.51631 2H21.0005V13.9H17.1503L13.4456 22.2358Z"}}]};

const ThumbDown1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'thumb-down-1-filled',
    ref,
    icon: element,
  },
));

ThumbDown1FilledIcon.displayName = 'ThumbDown1FilledIcon';

export default ThumbDown1FilledIcon;
